'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checklist = exports.Form = exports.Progress = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n    width: 100%; \n    height: 1em; \n    background: ', ';\n    border-radius: ', ';\n    appearance: none;\n    \n    \n    &[value]{\n        background: ', ';\n        border-radius: 2px;\n    }\n'], ['\n    width: 100%; \n    height: 1em; \n    background: ', ';\n    border-radius: ', ';\n    appearance: none;\n    \n    \n    &[value]{\n        background: ', ';\n        border-radius: 2px;\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    width: 100%;\n    max-width: 500px;\n'], ['\n    width: 100%;\n    max-width: 500px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    color: ', ';\n    position: relative;\n    z-index: 2;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    border-radius: ', ';\n    box-shadow: ', ';\n    padding: .5rem;\n    height: 3rem;\n    transition: .2s ease;\n    border: ', ';\n    border-color:  ', ';\n    background: ', ';\n    &:hover, &:focus-within{\n        background: ', ';\n        box-shadow: ', ';\n    }\n    svg:not(.no-margin-right) {\n        margin-right: .5em\n    }\n\n    .confirm-icon{\n        transition: .2s ease-out;\n        position: absolute;\n        right: .2em;\n        top: .2em;\n        transform: translateX(-1em);\n        padding: .3em;\n        opacity: 0;\n    }\n\n    ', '\n\n    ', '\n    \n    \n'], ['\n    color: ', ';\n    position: relative;\n    z-index: 2;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    border-radius: ', ';\n    box-shadow: ', ';\n    padding: .5rem;\n    height: 3rem;\n    transition: .2s ease;\n    border: ', ';\n    border-color:  ', ';\n    background: ', ';\n    &:hover, &:focus-within{\n        background: ', ';\n        box-shadow: ', ';\n    }\n    svg:not(.no-margin-right) {\n        margin-right: .5em\n    }\n\n    .confirm-icon{\n        transition: .2s ease-out;\n        position: absolute;\n        right: .2em;\n        top: .2em;\n        transform: translateX(-1em);\n        padding: .3em;\n        opacity: 0;\n    }\n\n    ', '\n\n    ', '\n    \n    \n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    border: none;\n    border-radius: ', ';\n    color: ', ';\n    background: none;\n    padding: 0.25rem 0;\n    width: 100%;\n    overflow: hidden;\n    font-size: 1em;\n    font: inherit;\n    \n    \n'], ['\n    border: none;\n    border-radius: ', ';\n    color: ', ';\n    background: none;\n    padding: 0.25rem 0;\n    width: 100%;\n    overflow: hidden;\n    font-size: 1em;\n    font: inherit;\n    \n    \n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    position: relative;\n    .icons {\n        position: absolute;\n        top: .25em;\n        right: .25em;\n    }\n    .confirm-icon{\n        transition: .2s ease-out;\n        position: absolute;\n        right: .2em;\n        top: .2em;\n        transform: translateX(-1em);\n        padding: .3em;\n        opacity: 0;\n    }\n\n    ', '\n'], ['\n    position: relative;\n    .icons {\n        position: absolute;\n        top: .25em;\n        right: .25em;\n    }\n    .confirm-icon{\n        transition: .2s ease-out;\n        position: absolute;\n        right: .2em;\n        top: .2em;\n        transform: translateX(-1em);\n        padding: .3em;\n        opacity: 0;\n    }\n\n    ', '\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    transition: .2s ease;\n    width: 100%; \n    border-radius: ', ';\n    min-height: 200px;\n    background: ', '; \n    border: ', ';\n    box-shadow: ', ';\n    padding: .5em; \n    font-size: 1em; \n    font-family: \'Quicksand\';\n    resize: vertical;\n    color: ', ';\n    &:hover, &:focus-within{\n        background: ', ';\n        box-shadow: ', ';\n    }\n    \n'], ['\n    transition: .2s ease;\n    width: 100%; \n    border-radius: ', ';\n    min-height: 200px;\n    background: ', '; \n    border: ', ';\n    box-shadow: ', ';\n    padding: .5em; \n    font-size: 1em; \n    font-family: \'Quicksand\';\n    resize: vertical;\n    color: ', ';\n    &:hover, &:focus-within{\n        background: ', ';\n        box-shadow: ', ';\n    }\n    \n']),
    _templateObject7 = _taggedTemplateLiteral(['\n    .select{   \n        position: relative;\n        z-index: 11;\n        .zyppd__control{\n            border-radius: ', ';\n            border: ', ';\n            background: ', ';\n            padding: 0rem;\n            box-shadow: ', ';\n            ', '\n            transition: .2s ease-in-out;\n            &--is-focused{\n                outline: inherit;\n            }\n            &:hover, &:focus-within{\n                background: ', ';\n                box-shadow: ', ';\n            }\n        }\n        .zypdd__menu {\n            border-radius: ', ';\n            background: ', ';\n            background: red;\n            border: none;\n            padding: 1em;\n        }\n        .zyppd__option{\n            padding: 1em;\n            background: ', ';\n            color: ', ';\n            border: none;\n          \n            &:hover {\n                background: ', ';\n                // background: ', ';\n            }\n            &--is-focused{\n                background: ', ';\n            }\n        }\n        .zyppd__single-value{\n            color:  ', ';\n        }\n        .zyppd__indicator svg path {\n            fill:  ', ';\n        }\n\n    }\n    p {\n        margin: .2em .6em;\n    }\n'], ['\n    .select{   \n        position: relative;\n        z-index: 11;\n        .zyppd__control{\n            border-radius: ', ';\n            border: ', ';\n            background: ', ';\n            padding: 0rem;\n            box-shadow: ', ';\n            ', '\n            transition: .2s ease-in-out;\n            &--is-focused{\n                outline: inherit;\n            }\n            &:hover, &:focus-within{\n                background: ', ';\n                box-shadow: ', ';\n            }\n        }\n        .zypdd__menu {\n            border-radius: ', ';\n            background: ', ';\n            background: red;\n            border: none;\n            padding: 1em;\n        }\n        .zyppd__option{\n            padding: 1em;\n            background: ', ';\n            color: ', ';\n            border: none;\n          \n            &:hover {\n                background: ', ';\n                // background: ', ';\n            }\n            &--is-focused{\n                background: ', ';\n            }\n        }\n        .zyppd__single-value{\n            color:  ', ';\n        }\n        .zyppd__indicator svg path {\n            fill:  ', ';\n        }\n\n    }\n    p {\n        margin: .2em .6em;\n    }\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n    display: block;\n    position: relative;\n    padding-left: 35px;\n    margin-bottom: 12px;\n    cursor: pointer;\n    user-select: none;\n    input {\n        position: absolute;\n        opacity: 0;\n        cursor: pointer;\n    }\n    .checkmark {\n        position: absolute;\n        top: 50%;\n        transform: translate(0, -50%);\n        left: 0;\n\n        border-radius: ', ';\n        border: ', ';\n        // background-color: ', ';\n        background: ', ';\n        // box-shadow: ', ';\n        width: 1.5rem;\n        height: 1.5rem;\n        display: flex; \n        justify-content: center;\n        align-items: center;\n        transition: .1s ease;\n        svg{\n            opacity: .4;\n            // transform: scale(0);\n            path {\n                fill: ', ';\n            }\n            \n        }\n        &.checked {\n            box-shadow: ', ';\n            background: ', ';\n            svg {\n                opacity: 1;\n            }\n          }\n    }\n    \n\n'], ['\n    display: block;\n    position: relative;\n    padding-left: 35px;\n    margin-bottom: 12px;\n    cursor: pointer;\n    user-select: none;\n    input {\n        position: absolute;\n        opacity: 0;\n        cursor: pointer;\n    }\n    .checkmark {\n        position: absolute;\n        top: 50%;\n        transform: translate(0, -50%);\n        left: 0;\n\n        border-radius: ', ';\n        border: ', ';\n        // background-color: ', ';\n        background: ', ';\n        // box-shadow: ', ';\n        width: 1.5rem;\n        height: 1.5rem;\n        display: flex; \n        justify-content: center;\n        align-items: center;\n        transition: .1s ease;\n        svg{\n            opacity: .4;\n            // transform: scale(0);\n            path {\n                fill: ', ';\n            }\n            \n        }\n        &.checked {\n            box-shadow: ', ';\n            background: ', ';\n            svg {\n                opacity: 1;\n            }\n          }\n    }\n    \n\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n    padding: .5em;\n    border-radius: ', ';\n    font-weight: bold; \n    input {\n        display: none;\n    }\n    flex: 1 1 66px;\n    box-shadow: ', ';\n    ', '\n'], ['\n    padding: .5em;\n    border-radius: ', ';\n    font-weight: bold; \n    input {\n        display: none;\n    }\n    flex: 1 1 66px;\n    box-shadow: ', ';\n    ', '\n']);

exports.inputValidation = inputValidation;
exports.Input = Input;
exports.TextArea = TextArea;
exports.Select = Select;
exports.Checkbox = Checkbox;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _themes = require('../theme/themes');

var _chromaJs = require('chroma-js');

var _chromaJs2 = _interopRequireDefault(_chromaJs);

var _icons = require('./icons');

var _hooks = require('../hooks');

var _buttons = require('./buttons');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Progress = exports.Progress = _styledComponents2.default.progress(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.textColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.brandColor;
});

var Form = exports.Form = _styledComponents2.default.form(_templateObject2);

var Field = _styledComponents2.default.div(_templateObject3, function (_ref4) {
  var theme = _ref4.theme;
  return theme.textColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadius;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.shadow;
}, function (_ref7) {
  var theme = _ref7.theme,
      isValidated = _ref7.isValidated;
  return '.1rem solid ' + (0, _chromaJs2.default)(theme.foreground).darken(0.3);
}, function (_ref8) {
  var theme = _ref8.theme,
      isValidated = _ref8.isValidated;
  return isValidated ? theme.stateColors.success : (0, _chromaJs2.default)(theme.foreground).darken(0.3);
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.foreground;
}, function (_ref10) {
  var theme = _ref10.theme;
  return (0, _chromaJs2.default)(theme.foreground).brighten(0.5);
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.expandedShadow;
}, function (_ref12) {
  var editable = _ref12.editable;
  return editable && '\n        box-shadow: none;\n        border: 1px solid ' + function (_ref13) {
    var theme = _ref13.theme;
    return theme.middleground;
  } + ';\n        &:focus-within{\n            .confirm-icon{\n                transform: translate(0, 0);\n                opacity: 1;\n            }\n            .edit-icon{\n                display: none;\n            }\n        }\n        ';
}, function (_ref14) {
  var needsEditing = _ref14.needsEditing,
      theme = _ref14.theme;
  return needsEditing && '\n        \n            border: .1rem solid ' + (0, _chromaJs2.default)(theme.stateColors.warning) + ';\n            &::before{\n                content: \'Needs Updating\';\n                position: absolute;\n                font-size: 80%;\n                font-weight: 500;\n                z-index: -1;\n                top: 0;\n                transform: translate(0, calc(-100% - 0rem));\n                right: .5em;\n                padding: .2em 1em; \n                border-radius: ' + theme.borderRadius + ' ' + theme.borderRadius + ' 0 0;\n                color: ' + ((0, _chromaJs2.default)(theme.stateColors.warning).luminance() > 0.4 ? '#333;' : 'whitesmoke;') + '\n                background: ' + theme.stateColors.warning + ';\n                height: 20px;\n                \n            }\n        ';
});

var InputField = _styledComponents2.default.input(_templateObject4, function (_ref15) {
  var theme = _ref15.theme;
  return theme.borderRadius;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.textColor;
});

function inputValidation(type, value) {
  if (!type || !value) return;
  var validated = false;

  if (type === 'email') {
    return validated = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value);
  }

  if (type === 'text') {
    return validated = value.length > 1;
  }

  if (type === 'tel') {
    return validated = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(value);
  }

  if (type === 'password') {
    return validated = value.length > 5;
  }

  return validated;
}

function Input(_ref17, props) {
  var children = _ref17.children,
      type = _ref17.type,
      placeholder = _ref17.placeholder,
      _ref17$name = _ref17.name,
      name = _ref17$name === undefined ? '' : _ref17$name,
      _ref17$handleInput = _ref17.handleInput,
      handleInput = _ref17$handleInput === undefined ? function () {} : _ref17$handleInput,
      message = _ref17.message,
      _ref17$validationNeed = _ref17.validationNeeded,
      validationNeeded = _ref17$validationNeed === undefined ? true : _ref17$validationNeed,
      className = _ref17.className,
      _ref17$useStorage = _ref17.useStorage,
      useStorage = _ref17$useStorage === undefined ? false : _ref17$useStorage,
      value = _ref17.value,
      _ref17$disabled = _ref17.disabled,
      disabled = _ref17$disabled === undefined ? false : _ref17$disabled,
      _ref17$editable = _ref17.editable,
      editable = _ref17$editable === undefined ? false : _ref17$editable,
      _ref17$handleExit = _ref17.handleExit,
      handleExit = _ref17$handleExit === undefined ? false : _ref17$handleExit,
      _ref17$needsEditing = _ref17.needsEditing,
      needsEditing = _ref17$needsEditing === undefined ? false : _ref17$needsEditing;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isValidated = _useState2[0],
      setIsValidated = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      val = _useState4[0],
      setVal = _useState4[1];

  var _useLocalStorage = (0, _hooks.useLocalStorage)(name || 'placeholder'),
      _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
      storageVal = _useLocalStorage2[0],
      setStorageVal = _useLocalStorage2[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      input = _useState6[0],
      setInput = _useState6[1];

  function handleChange(e) {
    if (disabled) return; // name && useStorage && 

    if (name && useStorage) {
      setStorageVal(e.target.value);
      setVal(e.target.value);
    } else {
      setVal(e.target.value);
    }

    if (validationNeeded) {
      setIsValidated(inputValidation(e.target.type, e.target.value));
      return handleInput(e, inputValidation(e.target.type, e.target.value));
    }

    return handleInput(e, true);
  }

  (0, _react.useEffect)(function () {
    if (!type) return;
    validationNeeded && setIsValidated(inputValidation(type, val));
  }, [val, type]);
  var InputEl = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    setVal(value);

    if (name && useStorage) {
      storageVal && setVal(storageVal);
    }

    if (InputEl.current.firstChild && InputEl.current.firstChild.tagName === 'svg') {
      InputEl.current.classList.add('with-icon');
    }
  }, []);
  return _react2.default.createElement('div', null, message && _react2.default.createElement('p', {
    style: {
      margin: '.25em .5em'
    }
  }, message), _react2.default.createElement(Field, {
    ref: InputEl,
    disabled: disabled,
    isValidated: isValidated,
    validationNeeded: validationNeeded,
    editable: editable,
    needsEditing: needsEditing
  }, children, _react2.default.createElement(InputField, _extends({
    value: val,
    className: 'input',
    type: type,
    name: name,
    placeholder: placeholder,
    onChange: handleChange
  }, props, {
    onBlur: editable ? handleExit : null
  })), editable && _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_buttons.PrimaryBtn, {
    className: 'confirm-icon ',
    onClick: handleExit
  }, _react2.default.createElement(_icons.Tick, {
    className: 'no-margin-right',
    faint: true
  })), _react2.default.createElement(_icons.EditIcon, {
    className: 'edit-icon no-margin-right',
    faint: true
  }))));
}

var TextAreaContainer = _styledComponents2.default.div(_templateObject5, function (_ref18) {
  var editable = _ref18.editable;
  return editable && '\n        box-shadow: none;\n        border: .1rem solid ' + function (_ref19) {
    var theme = _ref19.theme;
    return theme.middleground;
  } + ';\n        &:focus-within{\n            .confirm-icon{\n                transform: translate(0, 0);\n                opacity: 1;\n            }\n            .edit-icon{\n                display: none;\n            }\n        }\n        ';
});

var TextAreaStyles = _styledComponents2.default.textarea(_templateObject6, function (_ref20) {
  var theme = _ref20.theme;
  return theme.borderRadius;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.foreground;
}, function (_ref22) {
  var theme = _ref22.theme;
  return '.1rem solid ' + (0, _chromaJs2.default)(theme.foreground).darken(0.3);
}, function (_ref23) {
  var theme = _ref23.theme,
      editable = _ref23.editable;
  return editable !== true && theme.shadow;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.textColor;
}, function (_ref25) {
  var theme = _ref25.theme;
  return (0, _chromaJs2.default)(theme.foreground).brighten(0.5);
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.expandedShadow;
});

function TextArea(_ref27, props) {
  var children = _ref27.children,
      type = _ref27.type,
      placeholder = _ref27.placeholder,
      _ref27$name = _ref27.name,
      name = _ref27$name === undefined ? '' : _ref27$name,
      _ref27$handleInput = _ref27.handleInput,
      handleInput = _ref27$handleInput === undefined ? function () {} : _ref27$handleInput,
      message = _ref27.message,
      _ref27$validationNeed = _ref27.validationNeeded,
      validationNeeded = _ref27$validationNeed === undefined ? true : _ref27$validationNeed,
      className = _ref27.className,
      _ref27$useStorage = _ref27.useStorage,
      useStorage = _ref27$useStorage === undefined ? false : _ref27$useStorage,
      _ref27$value = _ref27.value,
      value = _ref27$value === undefined ? "" : _ref27$value,
      _ref27$disabled = _ref27.disabled,
      disabled = _ref27$disabled === undefined ? false : _ref27$disabled,
      _ref27$editable = _ref27.editable,
      editable = _ref27$editable === undefined ? false : _ref27$editable,
      _ref27$handleExit = _ref27.handleExit,
      handleExit = _ref27$handleExit === undefined ? false : _ref27$handleExit;

  var _useState7 = (0, _react.useState)(value),
      _useState8 = _slicedToArray(_useState7, 2),
      val = _useState8[0],
      setVal = _useState8[1];

  function handleChange(e) {
    handleInput(e);
    setVal(e.target.value);
  }

  return _react2.default.createElement(_react2.default.Fragment, null, message && _react2.default.createElement('p', {
    style: {
      margin: '.25em .5em'
    }
  }, message), _react2.default.createElement(TextAreaContainer, {
    editable: editable
  }, editable && _react2.default.createElement('div', {
    className: 'icons'
  }, _react2.default.createElement(_buttons.PrimaryBtn, {
    className: 'confirm-icon',
    onClick: handleExit
  }, _react2.default.createElement(_icons.Tick, {
    faint: true
  })), _react2.default.createElement(_icons.EditIcon, {
    className: 'edit-icon',
    faint: true
  })), _react2.default.createElement(TextAreaStyles, {
    name: name,
    placeholder: placeholder,
    onChange: handleChange,
    value: val,
    onBlur: editable ? handleExit : null,
    editable: editable
  })));
}

var SelectContainer = _styledComponents2.default.div(_templateObject7, function (_ref28) {
  var theme = _ref28.theme;
  return theme.borderRadius;
}, function (_ref29) {
  var theme = _ref29.theme;
  return '.1rem solid ' + (0, _chromaJs2.default)(theme.foreground).darken(0.3);
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.foreground;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.shadow;
}, function (_ref32) {
  var isDisabled = _ref32.isDisabled;
  return isDisabled ? '\n                box-shadow: none;\n                opacity: .5;\n                ' : null;
}, function (_ref33) {
  var theme = _ref33.theme;
  return (0, _chromaJs2.default)(theme.foreground).brighten(0.5);
}, function (_ref34) {
  var theme = _ref34.theme;
  return theme.expandedShadow;
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.borderRadius;
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.foreground;
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.foreground;
}, function (_ref38) {
  var theme = _ref38.theme;
  return theme.textColor;
}, function (_ref39) {
  var theme = _ref39.theme;
  return (0, _chromaJs2.default)(theme.foreground).darken(0.2);
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.middleground;
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.middleground;
}, function (_ref42) {
  var theme = _ref42.theme;
  return theme.textColor;
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.textColor;
});

function Select(props, _ref44) {
  var style = _ref44.style,
      options = _ref44.options,
      name = _ref44.name,
      _ref44$label = _ref44.label,
      label = _ref44$label === undefined ? "select" : _ref44$label,
      _ref44$onChange = _ref44.onChange,
      onChange = _ref44$onChange === undefined ? function () {} : _ref44$onChange;
  return _react2.default.createElement(SelectContainer, {
    isDisabled: props.isDisabled
  }, props.message && _react2.default.createElement('p', null, ' ', props.message), _react2.default.createElement(_reactSelect2.default, _extends({
    style: style,
    options: options,
    className: 'select',
    classNamePrefix: 'zyppd',
    onChange: onChange
  }, props)));
}

var Check = _styledComponents2.default.label(_templateObject8, function (_ref45) {
  var theme = _ref45.theme;
  return theme.borderRadius;
}, function (_ref46) {
  var theme = _ref46.theme,
      checked = _ref46.checked;
  return '.1rem solid ' + (checked ? theme.brandColor : (0, _chromaJs2.default)(theme.background).darken(1));
}, function (_ref47) {
  var theme = _ref47.theme;
  return theme.foreground;
}, function (_ref48) {
  var theme = _ref48.theme;
  return theme.middleground;
}, function (_ref49) {
  var theme = _ref49.theme;
  return theme.shadow;
}, function (_ref50) {
  var theme = _ref50.theme,
      checked = _ref50.checked;
  return theme.textColor;
}, function (_ref51) {
  var theme = _ref51.theme;
  return theme.shadow;
}, function (_ref52) {
  var theme = _ref52.theme;
  return theme.brandColor;
});

function Checkbox(props, _ref53) {
  var label = _ref53.label,
      checked = _ref53.checked,
      onClick = _ref53.onClick,
      name = _ref53.name;

  function handleClick(e) {
    return onClick && onClick(_extends({}, e, _defineProperty({}, e.target, _extends({}, e.target, {
      value: props.checked
    }))));
  }

  return _react2.default.createElement(Check, {
    checked: props.checked
  }, props.label, _react2.default.createElement('input', _extends({
    name: props.name,
    type: 'checkbox',
    checked: props.checked,
    value: props.checked,
    onChange: function onChange(e) {
      return handleClick(e);
    }
  }, props)), _react2.default.createElement('span', {
    className: 'checkmark ' + (props.checked ? 'checked' : '')
  }, _react2.default.createElement(_icons.Tick, null)));
}

var CheckBtnStyle = _styledComponents2.default.label(_templateObject9, function (_ref54) {
  var theme = _ref54.theme;
  return 'calc(' + theme.borderRadius + ' * 3)';
}, function (_ref55) {
  var theme = _ref55.theme;
  return theme.shadow;
}, function (_ref56) {
  var checked = _ref56.checked,
      theme = _ref56.theme;
  return checked && '\n                background: ' + theme.stateColors.positive + ';\n            ';
});

var Checklist = exports.Checklist = function Checklist(_ref57) {
  var options = _ref57.options,
      onClick = _ref57.onClick;

  var _useState9 = (0, _react.useState)(!!value),
      _useState10 = _slicedToArray(_useState9, 2),
      checked = _useState10[0],
      setChecked = _useState10[1];

  (0, _react.useEffect)(function () {
    onClick(value);
  }, [checked]);

  function handleChange() {
    setChecked(!checked);
    onClick(value);
  }

  return _react2.default.createElement(CheckBtnStyle, {
    checked: checked
  }, _react2.default.createElement('input', {
    onChange: function onChange() {
      return handleChange();
    },
    type: 'checkbox',
    name: name
  }), label);
};